module.exports = __webpack_public_path__ + "static/media/qr-code.7f7c1349.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/qr-code.png
// module id = 10009
// module chunks = 23